export const SHOW_MENU_WHITELIST: string[] = [
  /** about us **/
  '/about-us',
  '/par-mums',
  '/apie-mus',
  '/meist',

  /** company history **/
  '/company-history',
  '/uznemuma-vesture',
  '/imones-istorija',
  '/ettevotte-ajalugu',

  /** awards **/
  '/awards',
  '/apbalvojumi',
  '/auhinnad',
  '/apdovanojimai'
]

export const NEWS_ROOM_NAMES = new Set([
  'newsroom',
  'preses-telpa',
  'pranesimai-spaudai',
  'lehdistotiedotteet',
  'pressiteated',
  'pressemitteilungen'
])

export const LOCALE_LIST = ['en', 'lv', 'lt', 'et']
